
import { supabase } from '@/integrations/supabase/client';
import { WizardFormData } from '../types';

export const useProviderSubmit = () => {
  const createProvider = async (formData: WizardFormData) => {
    if (!formData.provider) {
      return null;
    }

    const { data: providerData, error: providerError } = await supabase
      .from('strategy_provider')
      .insert([{
        name: formData.provider.name,
        url: formData.provider.url,
        active: formData.provider.active
      }])
      .select('id')
      .single();
    
    if (providerError) {
      throw new Error(`Error creating provider: ${providerError.message}`);
    }
    
    return providerData.id;
  };

  return { createProvider };
};
